import Spinner from '@/assets/icons/spinner'
import { Button, Divider } from '@/components'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Icons } from '@/theme/Images'
import PropTypes from 'prop-types'

const PlaidInstantAuthFailedModal = ({ isOpen, onClose, onPayByCheck, onContinue, isContinueLoading = false }) => {
  return (
    <Dialog onOpenChange={onClose} open={isOpen}>
      <DialogContent
        className="max-w-[92%] rounded-lg md:max-w-[480px] overflow-y-auto max-h-[95%]"
        data-testid="plaid-instant-auth-failed-modal-content"
      >
        <div className="flex flex-row justify-start items-start p-5 pb-2">
          <div className="flex self-start items-center justify-center bg-gradient-to-r from-[--brand-850] to-[--brand-900] min-w-12 min-h-12 rounded-[10px]">
            <Icons.BankIcon />
          </div>
          <DialogHeader className="pt-0 pl-4 w-[215px] md:w-[368px]">
            <div className="flex flex-col justify-center items-start">
              <DialogTitle className="leading-7 text-dGray-900 text-lg font-inter text-left">
                Account Verification Failed
              </DialogTitle>
              <DialogDescription className="text-dGray-600 text-start pt-1 w-[215px] md:w-[368px]">
                We couldn&apos;t verify your account. You can still connect your account for repayment by entering your
                routing and account numbers into Plaid and confirming two small deposits. We won&apos;t see your account
                details. Plaid gives us a secure token that we use to process repayments. If you prefer, you can also
                choose to repay by check instead.
              </DialogDescription>
            </div>
          </DialogHeader>
        </div>
        <Divider />
        <DialogFooter className="w-full p-5 gap-3">
          <Button
            id="pay-by-check-button"
            aria-label="Pay by Check"
            variant="outlineSecondary"
            className="w-full"
            onClick={onPayByCheck}
          >
            Pay by Check
          </Button>
          <Button
            id="continue-button"
            aria-label="Continue"
            type="button"
            className="w-full"
            onClick={onContinue}
            disabled={isContinueLoading}
          >
            {isContinueLoading ? <Spinner size="20" stroke="#ffffff" /> : 'Continue'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

PlaidInstantAuthFailedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPayByCheck: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  isContinueLoading: PropTypes.bool,
}

export default PlaidInstantAuthFailedModal
